import { canProject } from '@allemnii-pulse/shared';
import { useProject } from '../projects/ProjectProvider.js';
import { ActivityFeed } from './ActivityFeed.js';

export function ProjectActivityPage() {
  const { projectId, project, role } = useProject();
  if (!project) return <div className="p-4 text-sm text-muted sm:p-6">Loading…</div>;
  // The tab is hidden from viewers; this covers a direct link. The rules refuse the read anyway.
  if (!canProject(role, 'project.activity.read')) {
    return (
      <div className="mx-auto max-w-2xl p-4 text-sm text-muted sm:p-6">
        Project activity isn't available to viewers.
      </div>
    );
  }
  return (
    <div className="mx-auto max-w-2xl p-4 sm:p-6">
      <ActivityFeed projectId={projectId} />
    </div>
  );
}
